import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import * as Yup from "yup";
import { ClientLocationDto } from "src/store/clients/type";
import { updateClientLocation } from "src/store/clients/saga";

const LocationEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: ClientLocationDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Clients.Locations.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          ClientId: data.ClientId,
          LocationTitle: "",
          AddressDetail: "",
          Default: true,
          Latitude: "",
          Longitude: "",
        }}
        validationSchema={Yup.object().shape({
          ClientId: Yup.string().required(t("Required").toString()),
          Latitude: Yup.string().required(t("Required").toString()),
          Longitude: Yup.string().required(t("Required").toString()),
          LocationTitle: Yup.string().required(t("Required").toString()),
          AddressDetail: Yup.string().required(t("Required").toString()),
        })}
        onSubmit={(values) => {
          dispatch(
            updateClientLocation({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        inputs={[
          {
            field: "LocationTitle",
            label: t("Clients.Locations.Title").toString(),
          },
          {
            field: "LocationTitle",
            label: t("Clients.Locations.AddressDetail").toString(),
            type: "textarea",
          },
          {
            field: "Default",
            label: t("Clients.Locations.Default").toString(),
            type: "switch",
            col: 6,
          },
          {
            field: "Longitude",
            label: "",
            googlemap: {
              latField: "Latitude",
              lonField: "Longitude",
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default LocationEditForm;
